module.exports = {
  tokenInvalid: 'The current login has expired, please log in again.',
  requestError: 'Request error',
  timeOut: 'Gateway Time-out',
  code404: 'Request failed with status code 404',
  loginNameExists: 'Login name or mailbox already exists!',
  codeInvalid: 'The authorization code is invalid or has expired',
  accountExpired: 'User account has expired',
  systemError: 'Unknown system exception'
}
